export enum ResourceBookingFlowEnum {
    Standard = 0,
    HotDesk = 1,
    Workspace = 2
}